'use strict';

var _reactTransformCatchErrors2 = require('react-transform-catch-errors');

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

var _reactTransformCatchErrors3 = _interopRequireDefault(_reactTransformCatchErrors2);

var _react = require('react');

var _redboxReact = require('redbox-react');

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

exports.__esModule = true;

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _reactRedux = require('react-redux');

var _components2 = require('../../components');

var _components = {
  _$PostRelated: {
    displayName: 'PostRelated'
  }
};

var _reactComponentWrapper = _reactTransformCatchErrors3['default']({
  filename: '/var/www/websites/blog.paymentwall.com/releases/20220825105928/src/components/PostSingle/PostRelated.js',
  components: _components,
  locals: [],
  imports: [_react, _redboxReact]
});

var _reactComponentWrapper2 = _reactTransformCatchErrors3['default']({
  filename: '/var/www/websites/blog.paymentwall.com/releases/20220825105928/src/components/PostSingle/PostRelated.js',
  components: _components,
  locals: [],
  imports: [_react, _redboxReact]
});

function _wrapComponent(uniqueId) {
  return function (ReactClass) {
    return _reactComponentWrapper2(_reactComponentWrapper(ReactClass, uniqueId), uniqueId);
  };
}

var PostRelated = (function (_Component) {
  _inherits(PostRelated, _Component);

  function PostRelated() {
    _classCallCheck(this, _PostRelated);

    _Component.apply(this, arguments);
  }

  PostRelated.prototype.renderRelatedPosts = function renderRelatedPosts() {
    var _props = this.props;
    var post = _props.post;
    var posts = _props.posts;
    var loading = _props.loading;
    var loaded = _props.loaded;

    if (loading || !loaded) {
      return _react2['default'].createElement(_components2.AppLoader, { theme: 'dark', size: '25' });
    }

    var count = 0;
    return _react2['default'].createElement(
      'div',
      { className: 'post-related__items animated-300 fadeInUp' },
      posts.map(function (related) {
        if (count < 3 && related.categories.names[0].name === post[0].categories.names[0].name && related.id !== post[0].id) {
          count++;
          return _react2['default'].createElement(
            _reactRouter.Link,
            { to: '/' + related.categories.names[0].name + '/' + related.slug, className: 'post-related__item', key: related.id },
            _react2['default'].createElement(
              'div',
              { className: 'post-related__item-content' },
              _react2['default'].createElement(
                'div',
                { className: 'post-related__item-sub-heading' },
                related.subtitle ? related.subtitle.rendered : ''
              ),
              _react2['default'].createElement(
                'div',
                { className: 'post-related__item-heading' },
                related.title.rendered
              )
            )
          );
        }
      })
    );
  };

  PostRelated.prototype.render = function render() {
    return _react2['default'].createElement(
      'div',
      { className: 'post-related' },
      _react2['default'].createElement(
        'div',
        { className: 'post-related__heading' },
        'Related articles'
      ),
      this.renderRelatedPosts()
    );
  };

  _createClass(PostRelated, null, [{
    key: 'propTypes',
    value: {
      post: _react.PropTypes.array,
      posts: _react.PropTypes.array,
      loading: _react.PropTypes.bool,
      loaded: _react.PropTypes.bool
    },
    enumerable: true
  }]);

  var _PostRelated = PostRelated;
  PostRelated = _wrapComponent('_$PostRelated')(PostRelated) || PostRelated;
  PostRelated = _reactRedux.connect(function (state) {
    return {
      post: state.post.data,
      posts: state.posts.data,
      loading: state.posts.loading,
      loaded: state.posts.loaded
    };
  })(PostRelated) || PostRelated;
  return PostRelated;
})(_react.Component);

exports['default'] = PostRelated;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PostSingle/PostRelated.js
// module id = 313
// module chunks = 0